module.exports = __webpack_public_path__ + "img/sprinkle-9.d844ff04.jpg";